/**
 * @generated SignedSource<<0c89f2c35b5f4380b82981ec524bb840>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomContentInput = {
  attribs?: unknown | null | undefined;
  row: number;
  type: string;
};
export type articlePaginationQuery$variables = {
  customContents?: ReadonlyArray<CustomContentInput | null | undefined> | null | undefined;
  entityId: string;
};
export type articlePaginationQuery$data = {
  readonly article: {
    readonly " $fragmentSpreads": FragmentRefs<"articleDividerArticle" | "articlePaginationCheckerArticle" | "articlePaginationNavigationHistoryArticle" | "articlePaywallCheckerContent" | "articleRenderArticle" | "contextsContentReadMoreContextProviderContent" | "helpersCheckIsPostiesArticle" | "helpersCheckIsStyleArticle" | "topBannerContent">;
  };
};
export type articlePaginationQuery = {
  response: articlePaginationQuery$data;
  variables: articlePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customContents"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityId"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "entityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "customContents",
    "variableName": "customContents"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableFollow",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v23 = [
  (v4/*: any*/),
  (v8/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v23/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v26 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ArticleType",
    "kind": "LinkedField",
    "name": "value",
    "plural": true,
    "selections": (v23/*: any*/),
    "storageKey": null
  }
],
v27 = {
  "alias": "articleTypes",
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v23/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    (v27/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "types",
  "storageKey": null
},
v33 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "AUTHOR_IMAGE"
    }
  }
],
v34 = [
  (v21/*: any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v36 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isSeriesItemResult"
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSlideshow",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "237x147"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": "style(filter:{\"style\":\"237x147\"})"
},
v41 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    (v22/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    (v31/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v42 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v43 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    (v4/*: any*/),
    (v11/*: any*/),
    (v10/*: any*/),
    (v22/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    (v31/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v45 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "768x768"
    }
  }
],
v46 = {
  "alias": "size768x768",
  "args": (v45/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": "style(filter:{\"style\":\"768x768\"})"
},
v47 = {
  "alias": "sizeLandscape250x99",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "landscape_250_99"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v49 = [
  (v48/*: any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v50/*: any*/),
    (v51/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v49/*: any*/),
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    (v8/*: any*/),
    (v43/*: any*/)
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "460x323"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": "style(filter:{\"style\":\"460x323\"})"
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v38/*: any*/),
    (v57/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    (v27/*: any*/),
    (v28/*: any*/),
    (v30/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v8/*: any*/),
    (v52/*: any*/)
  ],
  "storageKey": null
},
v62 = [
  (v52/*: any*/)
],
v63 = {
  "kind": "InlineFragment",
  "selections": (v62/*: any*/),
  "type": "Article",
  "abstractKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v60/*: any*/),
    (v61/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegment",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v52/*: any*/),
            (v8/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v44/*: any*/),
    (v63/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "articlePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Article",
        "kind": "LinkedField",
        "name": "article",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topBannerContent"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "articleDividerArticle"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "articlePaginationCheckerArticle"
          },
          {
            "args": (v3/*: any*/),
            "kind": "FragmentSpread",
            "name": "articlePaginationNavigationHistoryArticle"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "articlePaywallCheckerContent"
          },
          {
            "args": (v3/*: any*/),
            "kind": "FragmentSpread",
            "name": "articleRenderArticle"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "helpersCheckIsPostiesArticle",
            "selections": (v7/*: any*/),
            "args": null,
            "argumentDefinitions": []
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "helpersCheckIsStyleArticle",
            "selections": (v7/*: any*/),
            "args": null,
            "argumentDefinitions": []
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "contextsContentReadMoreContextProviderContent"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "articlePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Article",
        "kind": "LinkedField",
        "name": "article",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SectionSegment",
            "kind": "LinkedField",
            "name": "sections",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "value",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleTypeSegment",
            "kind": "LinkedField",
            "name": "types",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArticleType",
                "kind": "LinkedField",
                "name": "value",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v10/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Sponsor",
                "kind": "LinkedField",
                "name": "sponsor",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v8/*: any*/),
                  (v16/*: any*/),
                  (v9/*: any*/),
                  (v17/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              (v21/*: any*/),
              (v11/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v10/*: any*/),
                  (v22/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v31/*: any*/)
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              }
            ],
            "storageKey": null
          },
          (v28/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authorLocations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Author",
            "kind": "LinkedField",
            "name": "authors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "location",
                "storageKey": null
              },
              (v9/*: any*/),
              (v11/*: any*/),
              (v8/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": (v33/*: any*/),
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "300x300"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"300x300\"})"
                  }
                ],
                "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v10/*: any*/),
                  (v22/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v31/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "Author",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "Topic",
                    "abstractKey": null
                  }
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaywallType",
            "kind": "LinkedField",
            "name": "paywallTypes",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v8/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "version",
                "value": 2
              }
            ],
            "kind": "ScalarField",
            "name": "advertZone",
            "storageKey": "advertZone(version:2)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sentiment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contentLock",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Correction",
            "kind": "LinkedField",
            "name": "corrections",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "correction",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timestamp",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displaySlideShow",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormattedValue",
            "kind": "LinkedField",
            "name": "multimediaEmbed",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "seriesContainer",
            "plural": false,
            "selections": [
              (v35/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "series",
                "plural": true,
                "selections": [
                  (v36/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v35/*: any*/),
                      (v37/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          (v38/*: any*/),
                          (v18/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v10/*: any*/),
                      (v41/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  },
                  (v42/*: any*/)
                ],
                "storageKey": null
              },
              (v43/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "moreOnThisArticles",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v35/*: any*/),
              (v37/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  (v40/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v13/*: any*/),
              (v41/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "printHeadline",
            "storageKey": null
          },
          (v37/*: any*/),
          (v35/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Glossary",
            "kind": "LinkedField",
            "name": "glossary",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "term",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "translation",
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flattenTypeIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LiveArticle",
            "kind": "LinkedField",
            "name": "liveArticle",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v44/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AdditionalInfoBox",
            "kind": "LinkedField",
            "name": "additionalInfoBoxes",
            "plural": true,
            "selections": [
              (v38/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "images",
            "plural": true,
            "selections": [
              (v38/*: any*/),
              (v18/*: any*/),
              (v39/*: any*/),
              (v46/*: any*/),
              {
                "alias": "size800x1200",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "style": "800x1200"
                    }
                  }
                ],
                "concreteType": "ImageStyle",
                "kind": "LinkedField",
                "name": "style",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": "style(filter:{\"style\":\"800x1200\"})"
              },
              (v47/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "coverHero",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "type": "HERO"
                }
              }
            ],
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": (v19/*: any*/),
            "storageKey": "image(filter:{\"type\":\"HERO\"})"
          },
          (v11/*: any*/),
          {
            "alias": "coverDesktop",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "type": "COVER"
                }
              }
            ],
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v47/*: any*/)
            ],
            "storageKey": "image(filter:{\"type\":\"COVER\"})"
          },
          {
            "alias": "coverMobile",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "type": "COVER_MOBILE"
                }
              }
            ],
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": (v19/*: any*/),
            "storageKey": "image(filter:{\"type\":\"COVER_MOBILE\"})"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "relatedLinks",
            "storageKey": null
          },
          (v52/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sponsor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FactSheet",
            "kind": "LinkedField",
            "name": "factSheets",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "series",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v36/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleTypeSegment",
                    "kind": "LinkedField",
                    "name": "types",
                    "plural": true,
                    "selections": (v26/*: any*/),
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v35/*: any*/),
                  (v37/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v58/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      (v10/*: any*/),
                      (v22/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v59/*: any*/)
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SectionSegment",
                        "kind": "LinkedField",
                        "name": "sections",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Section",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": (v62/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v44/*: any*/),
                      (v63/*: any*/)
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  }
                ],
                "type": "Article",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duration",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v35/*: any*/),
                  (v37/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v64/*: any*/),
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v38/*: any*/),
                      (v17/*: any*/),
                      (v57/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v65/*: any*/)
                ],
                "type": "Video",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v35/*: any*/),
                  (v37/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v64/*: any*/),
                  (v56/*: any*/),
                  (v58/*: any*/),
                  (v65/*: any*/)
                ],
                "type": "Podcast",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v11/*: any*/),
                  (v10/*: any*/),
                  (v22/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v59/*: any*/)
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              },
              (v42/*: any*/)
            ],
            "storageKey": null
          },
          (v51/*: any*/),
          (v54/*: any*/),
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SectionSegment",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": true,
                    "selections": [
                      (v52/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v22/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v31/*: any*/)
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v60/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topics",
                "plural": true,
                "selections": (v62/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Author",
                "kind": "LinkedField",
                "name": "authors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SocialLink",
                    "kind": "LinkedField",
                    "name": "socialLinks",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "class",
                        "storageKey": null
                      },
                      (v38/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bio",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "areaOfExpertise",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": [
                  {
                    "alias": "size1280x720",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "wide_landscape"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                  },
                  {
                    "alias": "size1200x800",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "1200x800"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"1200x800\"})"
                  },
                  {
                    "alias": "size1020x680",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "1020x680"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"1020x680\"})"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              (v66/*: any*/),
              (v53/*: any*/),
              (v55/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleTypeSegment",
                    "kind": "LinkedField",
                    "name": "types",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleType",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormattedValue",
                            "kind": "LinkedField",
                            "name": "description",
                            "plural": false,
                            "selections": [
                              (v48/*: any*/),
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v33/*: any*/),
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
                      },
                      {
                        "alias": "authorLarge",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "type": "AUTHOR_LARGE"
                            }
                          }
                        ],
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": "image(filter:{\"type\":\"AUTHOR_LARGE\"})"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "styleMoreOnThisArticles",
                    "args": null,
                    "concreteType": "Article",
                    "kind": "LinkedField",
                    "name": "moreOnThisArticles",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v10/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v11/*: any*/),
                          (v22/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v31/*: any*/)
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsor",
                                "kind": "LinkedField",
                                "name": "sponsor",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v17/*: any*/),
                                  (v20/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v18/*: any*/),
                              (v38/*: any*/),
                              (v17/*: any*/),
                              (v46/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v35/*: any*/),
                          (v37/*: any*/),
                          (v66/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegment",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Section",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v9/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleTypeSegment",
                                "kind": "LinkedField",
                                "name": "types",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleType",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v4/*: any*/),
                                      (v50/*: any*/),
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Author",
                                "kind": "LinkedField",
                                "name": "authors",
                                "plural": true,
                                "selections": [
                                  (v32/*: any*/),
                                  (v8/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v28/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/)
                            ],
                            "type": "Video",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Article",
                "abstractKey": null
              }
            ],
            "type": "Content",
            "abstractKey": "__isContent"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v66/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "knowledgeQuestion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Sponsor",
                        "kind": "LinkedField",
                        "name": "sponsor",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      {
                        "alias": "generic_og",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "style": "og_image_scmp_generic"
                            }
                          }
                        ],
                        "concreteType": "ImageStyle",
                        "kind": "LinkedField",
                        "name": "style",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": "style(filter:{\"style\":\"og_image_scmp_generic\"})"
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "styles": [
                                "og_image_posties_article",
                                "og_image_scmp_analysis",
                                "og_image_scmp_explainer",
                                "og_image_scmp_editorial",
                                "og_image_scmp_fact_check",
                                "og_image_scmp_debate",
                                "og_image_scmp_live",
                                "og_image_scmp_obituary",
                                "og_image_scmp_opinion",
                                "og_image_scmp_review",
                                "og_image_scmp_series",
                                "og_image_scmp_generic"
                              ]
                            }
                          }
                        ],
                        "concreteType": "ImageStyle",
                        "kind": "LinkedField",
                        "name": "styles",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "style",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "styles(filter:{\"styles\":[\"og_image_posties_article\",\"og_image_scmp_analysis\",\"og_image_scmp_explainer\",\"og_image_scmp_editorial\",\"og_image_scmp_fact_check\",\"og_image_scmp_debate\",\"og_image_scmp_live\",\"og_image_scmp_obituary\",\"og_image_scmp_opinion\",\"og_image_scmp_review\",\"og_image_scmp_series\",\"og_image_scmp_generic\"]})"
                      },
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": (v45/*: any*/),
                        "concreteType": "ImageStyle",
                        "kind": "LinkedField",
                        "name": "style",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": "style(filter:{\"style\":\"768x768\"})"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "disableOffPlatformContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "published",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "subHeadline",
                    "plural": false,
                    "selections": (v49/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v3/*: any*/),
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": (v49/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "keywords",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "copyrighted",
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "type": "Article",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "fullSectionPath",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v4/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Section",
                "abstractKey": null
              }
            ],
            "type": "BaseWithApplicationAndUrlAlias",
            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2f63b7acb420f558c23966859b758a5e",
    "id": null,
    "metadata": {},
    "name": "articlePaginationQuery",
    "operationKind": "query",
    "text": "query articlePaginationQuery(\n  $entityId: String!\n  $customContents: [CustomContentInput]\n) {\n  article(filter: {entityId: $entityId}) {\n    ...topBannerContent\n    ...articleDividerArticle\n    ...articlePaginationCheckerArticle\n    ...articlePaginationNavigationHistoryArticle_4oKxOH\n    ...articlePaywallCheckerContent\n    ...articleRenderArticle_4oKxOH\n    ...helpersCheckIsPostiesArticle\n    ...helpersCheckIsStyleArticle\n    ...contextsContentReadMoreContextProviderContent\n    id\n  }\n}\n\nfragment appButtonContent on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment articleActionWidgetArticle on Article {\n  ...articleCommentsTriggerArticle\n  ...articleReactionArticle\n  entityId\n  urlAlias\n}\n\nfragment articleAdditionalInfoBoxArticle on AdditionalInfoBox {\n  title\n  description {\n    json\n  }\n}\n\nfragment articleAdditionalInfoBoxArticleContent on Content {\n  __isContent: __typename\n  ...contentSchemaRenderContent\n}\n\nfragment articleAuthorBlockArticle on Article {\n  ...articleDateContent\n  ...authorNamesArticle\n  authors {\n    entityId\n    ...entityFollowButtonBase\n    ...authorAvatarAuthor\n    id\n  }\n  ...helpersCheckCanShowInPlusPlatformArticle\n  ...helpersCheckIsPlusArticle\n  ...plusArticleAuthorBlockArticle\n}\n\nfragment articleAuthorDetailsContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    ...authorCardAuthor\n    bio\n    id\n  }\n}\n\nfragment articleBaseAdvertisingInfoArticle on Article {\n  advertZone(version: 2)\n  entityId\n  sentiment\n  contentLock\n  topics {\n    entityId\n    sponsor {\n      __typename\n      id\n    }\n    id\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment articleCommentsTriggerArticle on Article {\n  commentCount\n  entityId\n}\n\nfragment articleCorrectionsWidgetArticle on Article {\n  corrections {\n    correction {\n      json\n    }\n    timestamp\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment articleDateContent on Content {\n  __isContent: __typename\n  ...defaultArticleDateContent\n}\n\nfragment articleDividerArticle on Article {\n  ...helpersCheckIsStyleArticle\n}\n\nfragment articleImageGalleryContent on Content {\n  __isContent: __typename\n  ...helpersCheckIsStyleArticle\n  entityId\n  urlAlias\n  shortUrl\n  headline\n  socialHeadline\n}\n\nfragment articleLandingBannerArticle on Article {\n  ...articleSponsorContent\n  ...articleShareWidgetArticle\n  headline\n  topics {\n    ...entityLink\n    name\n    id\n  }\n  images {\n    isSlideshow\n    title\n    url\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n    size800x1200: style(filter: {style: \"800x1200\"}) {\n      url\n    }\n    sizeLandscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n  }\n  coverDesktop: image(filter: {type: COVER}) {\n    url\n    sizeLandscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n  }\n  coverMobile: image(filter: {type: COVER_MOBILE}) {\n    url\n  }\n}\n\nfragment articleLeadingArticle on Article {\n  entityId\n  displaySlideShow\n  ...articleLeadingImagesContent\n  ...contentCoverVideoContent\n  ...contentSchemaRenderContent\n  ...helpersIsArticleVideoAsHeroArticle\n}\n\nfragment articleLeadingImagesContent on Content {\n  __isContent: __typename\n  images {\n    title\n    url\n    isSlideshow\n    size1280x720: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size1020x680: style(filter: {style: \"1020x680\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n}\n\nfragment articleLeftHandSideWidgetsContent on Article {\n  ...seriesWidgetContent\n  ...topPicksWidgetContent\n  seriesContainer {\n    series {\n      __typename\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment articleMoreOnThisListArticle on Article {\n  moreOnThisArticles {\n    ...entityLink\n    entityId\n    headline\n    socialHeadline\n    urlAlias\n    images {\n      url\n      style(filter: {style: \"237x147\"}) {\n        url\n      }\n    }\n    id\n  }\n}\n\nfragment articleMoreOnThisListStyleArticle on Article {\n  styleMoreOnThisArticles: moreOnThisArticles {\n    ...entityLink\n    ...magazinesStyleArticleMoreOnThisContentItemContent\n    entityId\n    urlAlias\n    id\n  }\n}\n\nfragment articlePaginationCheckerArticle on Article {\n  ...helpersCheckIsPostiesArticle\n  ...helpersGetArticleTypeArticle\n}\n\nfragment articlePaginationNavigationHistoryArticle_4oKxOH on Article {\n  entityId\n  urlAlias\n  ...hooksTrackCurrentItemBase_4oKxOH\n}\n\nfragment articlePaywallCheckerContent on Content {\n  __isContent: __typename\n  ...hooksPaywallPromiseContent\n}\n\nfragment articlePaywallContainerArticle on Article {\n  entityId\n}\n\nfragment articlePrintHeadlineMessageArticle on Article {\n  printHeadline\n}\n\nfragment articleReactionArticle on Article {\n  entityId\n  sections {\n    value {\n      name\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      id\n    }\n  }\n  ...hooksArticleReactionUtilsArticle\n}\n\nfragment articleRenderArticle_4oKxOH on Article {\n  entityId\n  ...articleActionWidgetArticle\n  ...articleAdditionalInfoBoxArticleContent\n  ...articleAuthorBlockArticle\n  ...articleAuthorDetailsContent\n  ...articleBaseAdvertisingInfoArticle\n  ...articleCommentsTriggerArticle\n  ...articleCorrectionsWidgetArticle\n  ...articleImageGalleryContent\n  ...articleLeadingArticle\n  ...articleLeftHandSideWidgetsContent\n  ...articleMoreOnThisListArticle\n  ...articlePaywallContainerArticle\n  ...articlePrintHeadlineMessageArticle\n  ...articleReactionArticle\n  ...articleSectionsContent\n  ...articleShareWidgetArticle\n  ...articleSpeechInlineWidgetArticle\n  ...articleSpeechPlayerPortalArticle\n  ...articleSponsorContent\n  ...articleTopicFollowWidgetArticle\n  ...articleTopicsContent\n  ...articleVocabBoxArticle\n  ...contentBodyContent_4oKxOH\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentReadMoreButtonContent\n  ...contentSchemaRenderContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...genericArticleArticle\n  ...globalCheckerContent\n  ...helpersCheckCanShowInPlusPlatformArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsPostiesArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersGetArticleTypeArticle\n  ...hooksPostiesArticleArticle_4oKxOH\n  ...infographicArticleArticle\n  ...liveArticleArticle\n  ...longReadArticleArticle\n  ...morningStudioArticleContent\n  ...newsletterArticleArticle\n  ...opinionArticleContent\n  ...photoEssayArticleArticle\n  ...pianoIntegrationArticle\n  ...plusColumnsArticleContent\n  ...plusGenericArticleContent\n  ...seriesArticleArticle\n  ...styleArticleContent\n}\n\nfragment articleSectionsContent on Content {\n  __isContent: __typename\n  sections {\n    value {\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      name\n      id\n    }\n  }\n}\n\nfragment articleSeoArticle_4oKxOH on Article {\n  ...hooksArticleSeoArticle\n  ...helpersCheckIsPostiesArticle\n  entityId\n  publishedDate\n  updatedDate\n  summary {\n    text\n  }\n  subHeadline {\n    text\n  }\n  body(customContents: $customContents) {\n    text\n  }\n  keywords\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  topics {\n    name\n    entityId\n    id\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  images {\n    style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n}\n\nfragment articleShareWidgetArticle on Article {\n  ...contentShareWidgetContent\n  ...articleCommentsTriggerArticle\n  ...articleSpeechInlineWidgetArticle\n}\n\nfragment articleSpeechInlineWidgetArticle on Article {\n  entityId\n  ...genericArticleSpeechInlineWidgetGenericArticle\n}\n\nfragment articleSpeechPlayerPortalArticle on Article {\n  entityId\n  ...articleSpeechInlineWidgetArticle\n}\n\nfragment articleSponsorContent on Article {\n  topics {\n    entityId\n    sponsor {\n      description {\n        json\n      }\n      ...sponsorTagSponsor\n      id\n    }\n    id\n  }\n  ...helpersUseContentSponsorContent\n  ...helpersCheckIsMainTopicContent\n  ...contentSchemaRenderContent\n}\n\nfragment articleTitleArticle on Article {\n  types {\n    value {\n      name\n      id\n    }\n  }\n  authors {\n    name\n    id\n  }\n}\n\nfragment articleTopicFollowWidgetArticle on Article {\n  topics {\n    ...topicLinkTopic\n    ...entityFollowButtonBase\n    disableFollow\n    entityId\n    name\n    entityUuid\n    id\n  }\n}\n\nfragment articleTopicsContent on Content {\n  __isContent: __typename\n  topics {\n    ...topicLinkTopic\n    ...entityFollowButtonBase\n    entityId\n    entityUuid\n    name\n    id\n  }\n}\n\nfragment articleVocabBoxArticle on Article {\n  glossary {\n    term\n    translation\n    description {\n      json\n    }\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment atomsCurrentArticleAtomBase_4oKxOH on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    ...articleSeoArticle_4oKxOH\n    ...contentShareWidgetContent\n    ...headerContentBookmarkArticle\n    ...headerContentCommentTrigger\n    ...helpersCheckIsStyleArticle\n    ...helpersUseSharingUrl\n    ...hooksTrackPageViewArticle\n    ...hooksContentInterestArticle\n    ...hooksUseCurrentArticleIdsArticle\n    ...hooksUseNotificationReadStatusArticle\n    ...onboardingNewsletterSubscriptionArticle\n  }\n}\n\nfragment atomsCurrentNotificationSectionAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    fullSectionPath {\n      ...hooksUseNotificationsSection\n      id\n    }\n  }\n  ... on Article {\n    sections {\n      value {\n        ...hooksUseNotificationsSection\n        id\n      }\n    }\n  }\n}\n\nfragment atomsCurrentStyleCardCarouselWidgetSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sections {\n      value {\n        entityId\n        name\n        id\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      name\n      id\n    }\n  }\n}\n\nfragment atomsCurrentTakeoverAdSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sections {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n  }\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  entityUuid\n  name\n  types\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n}\n\nfragment authorBioAuthor on Author {\n  bio\n}\n\nfragment authorCardAuthor on Author {\n  ...styleAuthorCardAuthor\n  ...defaultAuthorCardAuthor\n  ...plusAuthorCardAuthor\n}\n\nfragment authorNameAuthor on Author {\n  ...entityLink\n  name\n  entityUuid\n}\n\nfragment authorNamesArticle on Article {\n  authorLocations\n  authors {\n    entityId\n    location\n    ...authorNameAuthor\n    id\n  }\n}\n\nfragment authorSocialLinksAuthor on Author {\n  socialLinks {\n    class\n    title\n    url\n  }\n}\n\nfragment bannerSeriesArticleArticle on Article {\n  ...sectionTagSeriesArticleArticle\n  ...contentShareWidgetContent\n  entityId\n  headline\n  urlAlias\n  socialHeadline\n  summary {\n    text\n  }\n  updatedDate\n  publishedDate\n  images {\n    isSlideshow\n    url\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n    size800x1200: style(filter: {style: \"800x1200\"}) {\n      url\n    }\n    sizeLandscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n  }\n  coverDesktop: image(filter: {type: COVER}) {\n    url\n    sizeLandscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n  }\n  coverMobile: image(filter: {type: COVER_MOBILE}) {\n    url\n  }\n}\n\nfragment blockquoteLongReadContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment blockquoteQuoteGenericPostiesArticleContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment blockquoteQuotePlusGenericArticleContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment breadcrumbNewsletterArticleArticle on Article {\n  types {\n    value {\n      name\n      id\n    }\n  }\n}\n\nfragment buttonArticleSpeechInlineWidgetGenericButtonArticle on Article {\n  entityId\n  socialHeadline\n  headline\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment contentBodyContent_4oKxOH on Content {\n  __isContent: __typename\n  entityId\n  body(customContents: $customContents) {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentCoverImageContent_1OCN1a on Content {\n  __isContent: __typename\n  images {\n    url\n    title\n    type\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverVideoContent on Content {\n  __isContent: __typename\n  ... on Article {\n    multimediaEmbed {\n      json\n    }\n    ...contentSchemaRenderContent\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveArticleArticle on Article {\n  ...itemLiveArticleContentArticle\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterArticleArticle on Article {\n  entityId\n  relatedLinks\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sections {\n    value {\n      relatedNewsletters {\n        ...helpersMassageToNewsletterItemNewsletter\n        id\n      }\n      id\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentReadMoreButtonContent on Content {\n  __isContent: __typename\n  ...appButtonContent\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contextsContentReadMoreContextProviderContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n  ...helpersCheckIsStyleArticle\n  ... on Article {\n    sponsorType\n  }\n}\n\nfragment contextsSeriesWidgetContextProviderArticle on Article {\n  ...seriesWidgetEntrypointHeadlineArticle\n  seriesContainer {\n    headline\n    id\n  }\n}\n\nfragment defaultArticleDateContent on Content {\n  __isContent: __typename\n  ...hooksArticleDateUtilsContent\n}\n\nfragment defaultAuthorCardAuthor on Author {\n  ...authorSocialLinksAuthor\n  ...authorAvatarAuthor\n  ...authorNameAuthor\n  ...authorBioAuthor\n  ...entityFollowButtonBase\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment factSheetLinkPlusGenericArticleContent on Article {\n  entityId\n  factSheets {\n    url\n    name\n  }\n  ...helpersGetArticleTypeArticle\n}\n\nfragment genericArticleArticle on Content {\n  __isContent: __typename\n  entityId\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n  ...globalCheckerContent\n  ...reduceWhitespaceByAvailableSpaceArticle\n}\n\nfragment genericArticleSpeechInlineWidgetGenericArticle on Article {\n  entityId\n  ...buttonArticleSpeechInlineWidgetGenericButtonArticle\n  ...hooksShowGenericInlineWidgetByArticleArticle\n  ...toolTipArticleSpeechWidgetToolTipArticle\n}\n\nfragment genericPostiesArticleContent_4oKxOH on Article {\n  sections {\n    value {\n      name\n      urlAlias\n      id\n    }\n  }\n  authors {\n    name\n    id\n  }\n  publishedDate\n  additionalInfoBoxes {\n    ...articleAdditionalInfoBoxArticle\n  }\n  ...genericPostiesArticleVocabBoxArticle\n  ...blockquoteQuoteGenericPostiesArticleContent\n  ...articleBaseAdvertisingInfoArticle\n  ...contentBodyContent_4oKxOH\n}\n\nfragment genericPostiesArticleVocabBoxArticle on Article {\n  glossary {\n    term\n    translation\n    description {\n      json\n    }\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment globalCheckerContent on Content {\n  __isContent: __typename\n  ...articlePaywallCheckerContent\n}\n\nfragment headerContentBookmarkArticle on Article {\n  entityId\n  urlAlias\n}\n\nfragment headerContentCommentTrigger on Article {\n  ...articleCommentsTriggerArticle\n}\n\nfragment headerMorningStudioArticle on Article {\n  ...articleSponsorContent\n  ...subheaderMorningStudioSubheaderContent\n  headline\n  coverDesktop: image(filter: {type: COVER}) {\n    url\n  }\n  coverMobile: image(filter: {type: COVER_MOBILE}) {\n    url\n  }\n}\n\nfragment headerNewsletterArticleArticle on Article {\n  headline\n  ...issuesNewsletterArticleArticle\n  ...breadcrumbNewsletterArticleArticle\n  ...widgetNewsletterArticleArticle\n}\n\nfragment headerOpinionArticle on Article {\n  types {\n    value {\n      name\n      description {\n        json\n      }\n      id\n    }\n  }\n  authors {\n    name\n    image(filter: {type: AUTHOR_IMAGE}) {\n      url\n    }\n    authorLarge: image(filter: {type: AUTHOR_LARGE}) {\n      url\n    }\n    id\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLongReadArticle\n  ...helpersCheckIsMorningStudioArticle\n  ...helpersCheckIsPhotoEssayArticle\n  ...helpersCheckIsPostiesArticle\n  ...helpersCheckIsPostiesPage\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPostiesArticle\n  ...helpersCheckIsPostiesPage\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckArticleIsInSectionsArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckCanShowInPlusPlatformArticle on Article {\n  ...helpersCheckArticleIsInSectionsArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersGetArticleTypeArticle\n  ...helpersUseContentSponsorContent\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on Section {\n  name\n}\n\nfragment helpersCheckIsLongReadArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsMorningStudioArticle on Article {\n  sponsorType\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPhotoEssayArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Article {\n  paywallTypes {\n    entityUuid\n    id\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostiesArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPostiesPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsStyleArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetArticleTypeArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersIsArchiveWallArticle on Article {\n  ...helpersIsVelocityWallArticle\n  createdDate\n  publishedDate\n  paywallTypes {\n    entityId\n    id\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersIsVelocityWallArticle on Article {\n  paywallTypes {\n    entityId\n    id\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment helpersUseSharingUrl on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment hooksArticleDateUtilsContent on Content {\n  __isContent: __typename\n  createdDate\n  publishedDate\n  updatedDate\n}\n\nfragment hooksArticleReactionUtilsArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n  topics {\n    entityId\n    id\n  }\n  entityId\n  sponsorType\n}\n\nfragment hooksArticleSeoArticle on Article {\n  ...helpersCheckIsPostiesArticle\n  ...helpersCheckIsPlusArticle\n  entityId\n  flag\n  knowledgeQuestion\n  headline\n  socialHeadline\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  authors {\n    entityId\n    id\n  }\n  topics {\n    sponsor {\n      entityId\n      id\n    }\n    id\n  }\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n  images {\n    generic_og: style(filter: {style: \"og_image_scmp_generic\"}) {\n      url\n    }\n    styles(filter: {styles: [\"og_image_posties_article\", \"og_image_scmp_analysis\", \"og_image_scmp_explainer\", \"og_image_scmp_editorial\", \"og_image_scmp_fact_check\", \"og_image_scmp_debate\", \"og_image_scmp_live\", \"og_image_scmp_obituary\", \"og_image_scmp_opinion\", \"og_image_scmp_review\", \"og_image_scmp_series\", \"og_image_scmp_generic\"]}) {\n      url\n      style\n    }\n    type\n  }\n  disableOffPlatformContent\n  published\n  sponsorType\n  urlAlias\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentInterestArticle on Article {\n  entityId\n  sentiment\n  urlAlias\n  types {\n    value {\n      name\n      id\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment hooksContentItemProvidersContent_3JkJ9S on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_1OCN1a\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n}\n\nfragment hooksPaywallPromiseContent on Content {\n  __isContent: __typename\n  entityId\n  ...helpersCheckIsPostiesArticle\n}\n\nfragment hooksPostiesArticleArticle_4oKxOH on Article {\n  ...genericPostiesArticleContent_4oKxOH\n  ...helpersGetArticleTypeArticle\n}\n\nfragment hooksShowGenericInlineWidgetByArticleArticle on Article {\n  ...helpersCheckIsPostiesArticle\n  ...hooksPaywallPromiseContent\n  entityId\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksTrackCurrentItemBase_4oKxOH on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ...atomsCurrentArticleAtomBase_4oKxOH\n  ...atomsCurrentNotificationSectionAtomBase\n  ...atomsCurrentTakeoverAdSectionsAtomBase\n  ...atomsCurrentStyleCardCarouselWidgetSectionsAtomBase\n}\n\nfragment hooksTrackPageViewArticle on Article {\n  entityId\n  publishedDate\n  headline\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  topics {\n    name\n    entityId\n    id\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  copyrighted\n  entityUuid\n  socialHeadline\n  sponsor\n}\n\nfragment hooksUseCurrentArticleIdsArticle on Article {\n  entityId\n  entityUuid\n}\n\nfragment hooksUseNotificationReadStatusArticle on Article {\n  entityId\n}\n\nfragment hooksUseNotificationsSection on Section {\n  ...notificationSection\n  entityId\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment infographicArticleArticle on Article {\n  ...landingBannerInfographicArticle\n  ...globalCheckerContent\n  ...blockquoteLongReadContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment issuesDropdownNewsletterArticleArticle on Article {\n  entityId\n}\n\nfragment issuesNewsletterArticleArticle on Article {\n  types {\n    value {\n      entityUuid\n      id\n    }\n  }\n  ...issuesDropdownNewsletterArticleArticle\n}\n\nfragment itemLiveArticleContentArticle on Article {\n  entityId\n  urlAlias\n  ...articleImageGalleryContent\n  ...contentSchemaRenderContent\n  ...contentShareWidgetContent\n}\n\nfragment itemSeriesArticleSeriesItemResult on SeriesItemResult {\n  __isSeriesItemResult: __typename\n  __typename\n  ...typeSeriesArticleItemSeriesItemResult\n  ...entityLink\n  ... on Article {\n    entityId\n    headline\n    socialHeadline\n    subHeadline {\n      json\n    }\n    updatedDate\n    summary {\n      json\n    }\n    authors {\n      ...entityLink\n      name\n      id\n    }\n    images {\n      title\n      style(filter: {style: \"460x323\"}) {\n        url\n      }\n      type\n    }\n    ...articleCommentArticle\n    ...contentSchemaRenderContent\n  }\n  ... on Video {\n    entityId\n    headline\n    socialHeadline\n    updatedDate\n    summary {\n      json\n    }\n    body {\n      json\n    }\n    authors {\n      ...entityLink\n      name\n      id\n    }\n    images {\n      title\n      type\n      style(filter: {style: \"460x323\"}) {\n        url\n      }\n    }\n    ...contentSchemaRenderContent\n  }\n  ... on Podcast {\n    entityId\n    headline\n    socialHeadline\n    updatedDate\n    summary {\n      json\n    }\n    body {\n      json\n    }\n    authors {\n      ...entityLink\n      name\n      id\n    }\n    images {\n      title\n      style(filter: {style: \"460x323\"}) {\n        url\n      }\n      type\n    }\n    ...contentSchemaRenderContent\n  }\n}\n\nfragment landingBannerInfographicArticle on Article {\n  ...articleSponsorContent\n  ...articleShareWidgetArticle\n  headline\n  topics {\n    ...entityLink\n    name\n    id\n  }\n  images {\n    title\n    url\n  }\n  coverHero: image(filter: {type: HERO}) {\n    url\n  }\n}\n\nfragment liveArticleArticle on Article {\n  entityId\n  entityUuid\n  ...articleImageGalleryContent\n  ...contentLiveArticleArticle\n  ...globalCheckerContent\n  ...newsletterWidgetLiveArticleArticle\n  ...reduceWhitespaceByAvailableSpaceArticle\n}\n\nfragment longReadArticleArticle on Article {\n  entityId\n  ...articleLandingBannerArticle\n  ...globalCheckerContent\n  ...blockquoteLongReadContent\n}\n\nfragment magazinesStyleArticleMoreOnThisContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...helpersCheckIsMainTopicContent\n  ...hooksContentItemProvidersContent_3JkJ9S\n}\n\nfragment morningStudioArticleContent on Content {\n  __isContent: __typename\n  ...globalCheckerContent\n  ...headerMorningStudioArticle\n}\n\nfragment newsletterArticleArticle on Article {\n  ...contentNewsletterArticleArticle\n  ...headerNewsletterArticleArticle\n  ...issuesNewsletterArticleArticle\n  ...widgetNewsletterArticleArticle\n}\n\nfragment newsletterWidgetLiveArticleArticle on Article {\n  ...contentNewsletterWidgetContent\n}\n\nfragment notificationSection on Section {\n  name\n}\n\nfragment onboardingNewsletterSubscriptionArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment opinionArticleContent on Content {\n  __isContent: __typename\n  entityId\n  ...globalCheckerContent\n  ...headerOpinionArticle\n  ...hooksContentHelperContent\n  ...contentSchemaRenderContent\n  ...reduceWhitespaceByAvailableSpaceArticle\n}\n\nfragment pagerSeriesArticleArticle on Article {\n  headline\n  entityId\n  urlAlias\n  series {\n    __typename\n    ... on Article {\n      entityId\n    }\n    ... on Video {\n      entityId\n    }\n    ... on Podcast {\n      entityId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...contentShareWidgetContent\n}\n\nfragment photoEssayArticleArticle on Article {\n  entityId\n  ...articleLandingBannerArticle\n  ...globalCheckerContent\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment pianoIntegrationArticle on Article {\n  __typename\n  contentLock\n  createdDate\n  entityId\n  entityUuid\n  headline\n  publishedDate\n  sponsor\n  sponsorType\n  urlAlias\n  authors {\n    name\n    id\n  }\n  sections {\n    value {\n      entityUuid\n      name\n      id\n    }\n  }\n  topics {\n    name\n    id\n  }\n  types {\n    value {\n      entityId\n      name\n      id\n    }\n  }\n  ...helpersAppBarVariantBase\n  ...hooksPaywallPromiseContent\n  ...helpersIsArchiveWallArticle\n  ...helpersIsVelocityWallArticle\n  ...helpersCheckIsPostiesArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckCanShowInPlusPlatformArticle\n}\n\nfragment plusArticleAuthorBlockArticle on Article {\n  ...articleDateContent\n  ...authorNamesArticle\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    id\n  }\n}\n\nfragment plusArticleTitleArticle on Article {\n  ...hooksContentHelperContent\n  ...articleTitleArticle\n  ...plusArticleTypeTitleContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment plusArticleTypeTitleContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n}\n\nfragment plusAuthorCardAuthor on Author {\n  ...authorAvatarAuthor\n  ...authorNameAuthor\n  ...authorBioAuthor\n  areaOfExpertise\n}\n\nfragment plusColumnsArticleContent on Content {\n  __isContent: __typename\n  ...articleTitleArticle\n  ...blockquoteQuotePlusGenericArticleContent\n  ...hooksContentHelperContent\n}\n\nfragment plusGenericArticleContent on Article {\n  ...blockquoteQuotePlusGenericArticleContent\n  ...factSheetLinkPlusGenericArticleContent\n  ...plusArticleTitleArticle\n}\n\nfragment reduceWhitespaceByAvailableSpaceArticle on Article {\n  moreOnThisArticles {\n    __typename\n    id\n  }\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment sectionTagSeriesArticleArticle on Article {\n  sections {\n    value {\n      entityId\n      name\n      id\n    }\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment seriesArticleArticle on Article {\n  entityId\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n  series {\n    __typename\n    ...itemSeriesArticleSeriesItemResult\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...contentNewsletterWidgetContent\n  ...bannerSeriesArticleArticle\n  ...pagerSeriesArticleArticle\n  ...contentShareWidgetContent\n}\n\nfragment seriesWidgetContent on Article {\n  ...seriesWidgetDisplayArticle\n  ...contextsSeriesWidgetContextProviderArticle\n  entityId\n  seriesContainer {\n    series {\n      ...seriesWidgetDisplaySeriesItemResult\n      __typename\n      ... on BaseWithApplicationAndUrlAlias {\n        __isBaseWithApplicationAndUrlAlias: __typename\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment seriesWidgetDisplayArticle on Article {\n  ...seriesWidgetEntrypointHeadlineArticle\n  entityId\n  seriesContainer {\n    ...entityLink\n    id\n  }\n}\n\nfragment seriesWidgetDisplaySeriesItemResult on SeriesItemResult {\n  __isSeriesItemResult: __typename\n  ... on Article {\n    ...seriesWidgetItemContent\n    entityId\n    urlAlias\n  }\n}\n\nfragment seriesWidgetEntrypointHeadlineArticle on Article {\n  seriesContainer {\n    ...entityLink\n    headline\n    id\n  }\n}\n\nfragment seriesWidgetItemContent on Article {\n  ...entityLink\n  headline\n  socialHeadline\n  images {\n    title\n    url\n    isSlideshow\n    style(filter: {style: \"237x147\"}) {\n      url\n    }\n  }\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment styleArticleAuthorBlockArticle on Article {\n  createdDate\n  publishedDate\n  authors {\n    ...authorNameAuthor\n    entityId\n    id\n  }\n}\n\nfragment styleArticleContent on Content {\n  __isContent: __typename\n  ...articleImageGalleryContent\n  ...styleArticleAuthorBlockArticle\n  ...reduceWhitespaceByAvailableSpaceArticle\n  ...articleMoreOnThisListStyleArticle\n  entityId\n}\n\nfragment styleAuthorCardAuthor on Author {\n  ...authorSocialLinksAuthor\n  ...authorAvatarAuthor\n  ...authorNameAuthor\n  ...authorBioAuthor\n  ...entityFollowButtonBase\n}\n\nfragment subheaderMorningStudioSubheaderContent on Content {\n  __isContent: __typename\n  ...articleShareWidgetArticle\n  ...articleSponsorContent\n}\n\nfragment toolTipArticleSpeechWidgetToolTipArticle on Article {\n  entityId\n}\n\nfragment topBannerContent on Content {\n  __isContent: __typename\n  advertZone(version: 2)\n  sections {\n    value {\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      entityId\n      id\n    }\n  }\n}\n\nfragment topPicksWidgetContent on Article {\n  entityId\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n}\n\nfragment typeSeriesArticleItemSeriesItemResult on SeriesItemResult {\n  __isSeriesItemResult: __typename\n  ... on Article {\n    __typename\n    sections {\n      value {\n        entityId\n        id\n      }\n    }\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n  ... on Video {\n    __typename\n    duration\n  }\n  ... on Podcast {\n    __typename\n  }\n}\n\nfragment widgetNewsletterArticleArticle on Article {\n  relatedNewsletters {\n    ...helpersMassageToNewsletterItemNewsletter\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f62d47a2bddb3cf9e9ff11f0712317d";

export default node;
